import React from 'react';
import styles from './Modal.module.css';
import { createPortal } from 'react-dom';
import clsx from 'clsx';

interface ModalProps {
    onClose?: () => void;
    isMobile: boolean;
    children: React.ReactNode;
    className?: string;
}

const Modal = ({ onClose, isMobile, children, className }: ModalProps) => {
    return createPortal(
        <div
            className={clsx(styles.overlay, className)}
            onClick={onClose}
        >
            <div
                className={clsx(styles.dialog, {
                    [styles.mobile]: isMobile
                })}
                onClick={e => e.stopPropagation()} // evita cierre al hacer click dentro
            >
                {children}
            </div>
        </div>,
        document.body
    );
};

export default Modal;
